import React from 'react';
import Welcome_Banner from '../assets/welcome_banner.png';  

const Hero = () => {
  return (
    <section className="relative overflow-hidden from-blue-50 via-white to-blue-50 -mt-16">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-96 h-96 bg-brand-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-brand-secondary/10 rounded-full blur-3xl"></div>
        {/* Abstract digital patterns */}
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-brand-primary rounded-full opacity-60"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-brand-secondary rounded-full opacity-40"></div>
        <div className="absolute bottom-1/3 left-1/3 w-1.5 h-1.5 bg-brand-dark rounded-full opacity-50"></div>
        <div className="absolute top-2/3 right-1/4 w-1 h-1 bg-brand-primary rounded-full opacity-30"></div>
      </div>
      
      {/* Full Page Banner Content */}
      <div className="flex flex-col justify-start items-center relative z-10 pt-0">
        {/* Welcome Banner - Smaller Size */}
        <div className="w-full relative overflow-hidden mb-4 sm:mb-8 px-4 sm:px-0">
          <img 
            src={Welcome_Banner}
            alt="StarAI Welcome Banner" 
            className="w-full h-auto object-cover rounded-2xl shadow-xl"
          />
          {/* Optional overlay for better text readability if needed */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-purple-600/10 to-indigo-600/10 rounded-2xl"></div>
        </div>
        
        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16 relative z-10">
          {/* Left: Text Content */}
          <div className="flex-1 space-y-6 lg:space-y-8 max-w-2xl text-left">
            {/* Main Heading */}
            <div className="space-y-4 lg:space-y-6">
              <h1 className="text-display-3 font-display font-black leading-tight tracking-tighter">
                <span className="text-brand-dark">Chuyển đổi doanh nghiệp</span><br />
                <span className="text-brand-dark">với giải pháp AI</span><br />
                <span className="text-gradient">tiên tiến</span>
              </h1>
              
              {/* Description */}
              <p className="text-body-large text-gray-700 leading-relaxed max-w-xl font-body">
                StarAI cung cấp các giải pháp trí tuệ nhân tạo hàng đầu giúp thúc đẩy đổi mới, 
                hiệu quả và tăng trưởng cho các doanh nghiệp tiên phong.
              </p>
              
              {/* Features List */}
              <ul className="text-body text-gray-600 space-y-3 lg:space-y-4 font-body">
                <li className="flex items-center group justify-start">
                  <span className="w-3 h-3 bg-brand-primary rounded-full mr-4 group-hover:scale-125 transition-transform flex-shrink-0"></span>
                  <span className="group-hover:text-brand-primary transition-colors">Phát triển & tích hợp AI tùy chỉnh</span>
                </li>
                <li className="flex items-center group justify-start">
                  <span className="w-3 h-3 bg-brand-secondary rounded-full mr-4 group-hover:scale-125 transition-transform flex-shrink-0"></span>
                  <span className="group-hover:text-brand-primary transition-colors">Machine Learning & phân tích dữ liệu</span>
                </li>
                <li className="flex items-center group justify-start">
                  <span className="w-3 h-3 bg-brand-dark rounded-full mr-4 group-hover:scale-125 transition-transform flex-shrink-0"></span>
                  <span className="group-hover:text-brand-primary transition-colors">Tư vấn & chiến lược AI</span>
                </li>
              </ul>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 lg:gap-6 pt-4 lg:pt-6 justify-start">
              <button className="px-6 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 bg-brand-primary text-white font-display font-bold text-button tracking-wide rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 hover:bg-brand-secondary">
                Bắt đầu ngay
              </button>
              <button className="px-6 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 border-2 border-brand-primary text-brand-primary font-display font-bold text-button tracking-wide rounded-3xl hover:bg-brand-primary/10 transition-all duration-300">
                Tìm hiểu thêm
              </button>
            </div>
          </div>
          
          {/* Right: Digital Interface */}
          <div className="flex-1 flex justify-center mt-8 lg:mt-0">
            <div className="relative group">
              {/* Digital Tablet/Interface */}
              <div className="relative w-[280px] sm:w-[350px] md:w-[400px] lg:w-[500px] h-[220px] sm:h-[280px] md:h-[320px] lg:h-[400px] bg-gray-900 rounded-3xl shadow-2xl transform rotate-3 group-hover:rotate-0 transition-transform duration-500">
                {/* Screen Content */}
                <div className="absolute inset-2 sm:inset-3 lg:inset-4 bg-brand-dark rounded-2xl p-4 sm:p-6 lg:p-8">
                  {/* Data Visualization */}
                  <div className="grid grid-cols-3 gap-2 sm:gap-4 lg:gap-6 mb-4 sm:mb-6">
                    <div className="bg-brand-primary/20 rounded-lg p-2 sm:p-3 lg:p-4">
                      <div className="text-brand-primary text-xs sm:text-sm">AI Models</div>
                      <div className="text-white text-lg sm:text-xl lg:text-2xl font-bold">247</div>
                    </div>
                    <div className="bg-brand-secondary/20 rounded-lg p-2 sm:p-3 lg:p-4">
                      <div className="text-brand-secondary text-xs sm:text-sm">Accuracy</div>
                      <div className="text-white text-lg sm:text-xl lg:text-2xl font-bold">98.7%</div>
                    </div>
                    <div className="bg-brand-dark/50 rounded-lg p-2 sm:p-3 lg:p-4">
                      <div className="text-gray-300 text-xs sm:text-sm">Processing</div>
                      <div className="text-white text-lg sm:text-xl lg:text-2xl font-bold">1.2ms</div>
                    </div>
                  </div>
                  
                  {/* Central Glowing Element */}
                  <div className="flex justify-center mb-4 sm:mb-6">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-brand-primary rounded-full flex items-center justify-center shadow-lg animate-pulse">
                      <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-white rounded-full flex items-center justify-center">
                        <span className="text-brand-primary text-lg sm:text-xl lg:text-2xl font-bold">AI</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Network Lines */}
                  <div className="relative h-12 sm:h-16 lg:h-20">
                    <div className="absolute top-1/2 left-0 w-full h-1 bg-brand-primary/50"></div>
                    <div className="absolute top-0 left-1/2 w-1 h-full bg-brand-secondary/50"></div>
                  </div>
                </div>
              </div>
              
              {/* Robotic Arm - Hidden on mobile, visible on larger screens */}
              <div className="absolute -right-12 top-1/2 transform -translate-y-1/2 group-hover:translate-x-4 transition-transform duration-500 hidden lg:block">
                <div className="w-20 h-3 bg-white rounded-full shadow-lg"></div>
                <div className="w-3 h-12 bg-white rounded-full shadow-lg ml-17 -mt-6"></div>
                <div className="w-4 h-4 bg-blue-400 rounded-full shadow-lg ml-16 -mt-8 animate-pulse"></div>
              </div>
              
              {/* Abstract Digital Overlays - Hidden on mobile, visible on larger screens */}
              <div className="absolute -top-6 -right-6 w-40 h-40 border-2 border-blue-400/30 rounded-full hidden lg:block"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 border-2 border-purple-400/30 rounded-full hidden lg:block"></div>
              <div className="absolute top-1/2 left-0 w-20 h-20 border border-cyan-400/20 rounded-full hidden lg:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 